const el = document.querySelector('.button--add-to-cart')
const stickyBar = document.querySelector('.sticky-add-to-cart')

document.body.prepend(stickyBar)

if (el) {
  const observer = new window.IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('active')
        return
      }
      if (entry.boundingClientRect.top > 0) {
        stickyBar.classList.remove('active')
      } else {
        stickyBar.classList.add('active')
      }
    },
    {
      root: null,
      threshold: 0,
    }
  )

  observer.observe(el)
}
